var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":"","pa-0":""}},[_c('iframe',{staticClass:"storymap",attrs:{"src":"http://studymaps.ethz.ch/sustainability-atlas/maps/group2/"}})])}
var staticRenderFns = []

export { render, staticRenderFns }